import * as React from 'react';

export interface YesNoRadioButtonsProps {
  question: string;
  name: string;
  isYesChecked: boolean;
  isNoChecked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default class YesNoRadioButtons extends React.PureComponent<YesNoRadioButtonsProps, {}> {
  render(): JSX.Element {
    return (
      <div className="field control">
        <label className="label">{this.props.question}</label>
        <label className="radio">
          <input
            type="radio"
            name={this.props.name}
            value="yes"
            checked={this.props.isYesChecked}
            onChange={this.props.onChange}
          />
          {' Yes'}
        </label>
        <label className="radio">
          <input
            type="radio"
            name={this.props.name}
            value="no"
            checked={this.props.isNoChecked}
            onChange={this.props.onChange}
          />
          {' No'}
        </label>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/yesNoRadioButtons.tsx